import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {Secondary} from './buttons';
import {BounceLoader} from 'react-spinners';
import {Alert, Col, FormFile} from 'react-bootstrap';

export class FileUploader extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {loading: false};
  }

  handleAddNewFile = () => {
    this.setState({loading: true, error: false}, async () => {
      try {
        var formData = new FormData();
        var imagefile = document.querySelector('#image');
        formData.append('file', imagefile.files[0]);
        if (imagefile.files[0]) {
          try {
            const response = await fetch('/v2/api/file', {
              method: 'POST',
              credentials: 'include', // same as withCredentials: true
              body: formData,
            });

            if (!response.ok) {
              throw new Error(
                `Failed to upload file: ${response.status} - ${response.statusText}`
              );
            }

            const data = await response.json();
            // Hide loading, handle success
            this.setState({loading: false});
            this.props.onFileUploaded(data.fileUrl, this.state.image);
          } catch (error) {
            console.error('Error uploading file', error);
            // Hide loading, handle error
            this.setState({loading: false, error: true});
          }
        } else {
          this.setState({loading: false, error: true});
        }
      } catch (e) {
        this.setState({loading: false, error: true});
      }
    });
  };

  render() {
    return (
      <>
        <Form.Group as={Row}>
          <Col sm={this.props.sm ? this.props.sm : 4}>
            <FormFile
              onChange={() => {
                if (document.getElementById('image').files.length === 1) {
                  this.setState({
                    image: document.getElementById('image').files.item(0).name,
                    error: false,
                  });
                }
              }}
              id="image"
              label={
                this.state.image ? this.state.image : 'Choose file to upload...'
              }
              custom
            />
          </Col>
          <Col sm={3}>
            <Secondary onClick={this.handleAddNewFile}>Upload file</Secondary>
          </Col>
        </Form.Group>
        {this.state.loading && (
          <Row>
            <Col sm={'1'}>
              <BounceLoader />
            </Col>{' '}
            <Col>Uploading file...</Col>
          </Row>
        )}
        {this.state.error && (
          <Col sm={7}>
            <Alert variant={'warning'}>Error uploading file.</Alert>
          </Col>
        )}
      </>
    );
  }
}
